import { render } from "./5.vue?vue&type=template&id=836f3d82"
import script from "./5.vue?vue&type=script&lang=js"
export * from "./5.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__